export const buttonSize = '6.0rem';
